import React from 'react';
export function LogoCarousel() {
  const logos = [{
    name: 'Wix',
    domain: 'wix.com'
  }, {
    name: 'Framer',
    domain: 'framer.com'
  }, {
    name: 'Durable',
    domain: 'durable.co'
  }, {
    name: 'Hostinger',
    domain: 'hostinger.com'
  }, {
    name: '10Web',
    domain: '10web.io'
  }];
  // Only duplicate once for seamless -50% loop
  const allLogos = [...logos, ...logos];
  return <section className="py-6 md:py-16 bg-[#050505] overflow-hidden border-b border-white/5" data-id="element-262">
      <div className="relative w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-263">
        {/* Gradient Masks */}
        <div className="absolute left-0 top-0 bottom-0 w-20 md:w-32 bg-gradient-to-r from-[#050505] to-transparent z-10" data-id="element-264" />
        <div className="absolute right-0 top-0 bottom-0 w-20 md:w-32 bg-gradient-to-l from-[#050505] to-transparent z-10" data-id="element-265" />

        <div className="flex overflow-hidden" data-id="element-266">
          <div className="flex animate-infinite-scroll gap-24 md:gap-36 items-center" data-id="element-267">
            {allLogos.map((logo, index) => <div key={index} className="flex flex-col items-center gap-3 flex-shrink-0" data-id="element-268">
                <div className="w-20 h-20 md:w-24 md:h-24 opacity-70" data-id="element-269">
                  <img src={`https://logo.clearbit.com/${logo.domain}`} alt={`${logo.name} logo`} className="w-full h-full object-contain" onError={e => {
                ;
                (e.target as HTMLImageElement).style.display = 'none';
              }} data-id="element-270" />
                </div>
                <span className="text-xl md:text-2xl font-bold text-gray-300" data-id="element-271">
                  {logo.name}
                </span>
              </div>)}
          </div>
        </div>

        <style data-id="element-272">{`
          @keyframes infinite-scroll {
            from { transform: translateX(0); }
            to { transform: translateX(-50%); }
          }
          .animate-infinite-scroll {
            animation: infinite-scroll 30s linear infinite;
            width: max-content;
            will-change: transform;
          }
        `}</style>
      </div>
    </section>;
}